
declare const gtag: Function
import Vue from "vue";

import OptionsDropdown from "@/components/OptionsDropdown.vue";
import opportunitiesStore from "@/state/modules/opportunities";
import partnersStore from "@/state/modules/partners";
import optionsStore from '@/state/modules/options';
import {CSVConfig, exportCSV, getCSVHeaders} from '@/modules/csv';
import { adminUserPartner } from '../../state/modules/constants';

export default Vue.extend({
	name: "opportunities-page",
	page: {
		title: "Opportunities",
		meta: [
			{
				name: "description",
				content: "Page to list and filter opportunities of the partner",
			},
		],
	},
	components: {
		OptionsDropdown,
	},
	props: {
		theme: String,
		isSuperAdmin: {
			type: Boolean,
			default: false,
		},
		errorMsg: String,
	},
	computed: {
		defaultUser(): any { // returns ISelectOption or empty str
			if (!this.isSuperAdmin
				&& partnersStore.state.userPartner
				&& partnersStore.state.userPartner.officeId
				&& partnersStore.state.userPartner.name
			) {
				return {
					value: partnersStore.state.userPartner.officeId,
					label: partnersStore.state.userPartner.name,
				};
			} else if (partnersStore.state.userPartner === adminUserPartner || this.isSuperAdmin) {
				return "";
			} else {
				return null;
			}
		},
		opportunities() {
			return opportunitiesStore.state.opportunities;
		},
		opportunitiesToken(): number {
			return opportunitiesStore.state.opportunitiesToken;
		},
		paymentOptions(): ISelectOption[] {
			return optionsStore.state.boolean;
		},
		surveyOptions(): ISelectOption[] {
			return optionsStore.state.boolean;
		},
		scheduledOptions(): ISelectOption[] {
			return optionsStore.state.boolean;
		},
		serviceStatusOptions(): ISelectOption[] {
			return optionsStore.state.serviceStatus;
		},
		officeIdOptions(): ISelectOption[] {
			return optionsStore.state.officeId;
		},
		showLoadMoreButton(): boolean {
			return opportunitiesStore.state.opportunities.length >= opportunitiesStore.state.opportunitiesToken;
		},
		hasUniquePartnerId(): boolean {
			if (!this.$store.state.userInfo || this.$store.state.userInfo === null) {
				return false;
			} else {
				return this.$store.state.userInfo.partnerUniqueId && this.$store.state.userInfo.partnerUniqueId !== null;
			}
		},
		uniquePartnerId(): String {
			if (this.hasUniquePartnerId && this.isSuperAdmin === false) {
				return this.$store.state.userInfo.partnerUniqueId;
			} else {
				return "";
			}
		}
	},
	data(): any {
		return {
			filterOptions: {
				label: null,
				value: null
			},
			filters: {
				sortBy: "date",
				sortAscending: false,
				search: "",
			},
			csvHeaders: []
		}
	},
	beforeMount() {
		this.resetFilters();
		if(partnersStore.state.userPartner != null) {
			if (this.isSuperAdmin || this.filters.officeId) {
				opportunitiesStore.dispatchGetOpportunities({ params: this.filters }).then(() => {
					this.csvHeaders = getCSVHeaders({selector: '[data-csv-header]', label: 'data-csv-header'});
				});
			}
		}
	},
	watch: {
		defaultUser: function() {
			this.resetFilters();
			if (this.isSuperAdmin || this.filters.officeId) {
				opportunitiesStore.dispatchGetOpportunities({ params: this.filters }).then(() => {
					this.csvHeaders = getCSVHeaders({selector: '[data-csv-header]', label: 'data-csv-header'});
				});
			}
		}
	},
	methods: {
		changeSort(sortBy: string) {
			gtag('event', sortBy, { 'event_category': 'Opportunities', 'event_label': 'SortBy'});
			if (this.filters.sortBy === sortBy) {
				this.filters.sortAscending = !this.filters.sortAscending;
			} else {
				this.filters.sortBy = sortBy;
				this.filters.sortAscending = true;
			}
			opportunitiesStore.commitSetOpportunitiesToken(50);
			if (this.isSuperAdmin || this.filters.officeId) {
				opportunitiesStore.dispatchGetOpportunities({ params: this.filters });
			}
		},
		defaultFilters() {
			return {
				dateRangeStart: null,
				dateRangeEnd: null,
				scheduledDateRangeStart: null,
				scheduledDateRangeEnd: null,
				installDateRangeStart: null,
				installDateRangeEnd: null,
				payment: "",
				survey: "",
				scheduled: "",
				serviceStatus: "",
				repId: this.uniquePartnerId,
				officeId: this.defaultUser
			}
		},
		setFilters() {
			for (const [key, value] of Object.entries(this.filterOptions) as [string, any]) {
				if (value) {
					if (value.label !== undefined && value.label !== null) {
						this.filters[key] = key === "officeId" ? value.value : value.label;
					} else {
						this.filters[key] = value;
					}
				} else {
					delete this.filters[key];
				}
			}
		},
		submitFilters() {
			gtag('event', 'submitFilter', { 'event_category': 'Opportunities', 'event_label': 'Filter'});
			this.setFilters();
			opportunitiesStore.commitSetOpportunitiesToken(50);
			if (this.isSuperAdmin || this.filters.officeId) {
				opportunitiesStore.dispatchGetOpportunities({ params: this.filters });
			}
			this.$refs.filterOptionsDropdown.onCloseOptions();
		},
		resetFilters() {
			this.filterOptions = this.defaultFilters();
			for (const [key, value] of Object.entries(this.filters)) {
				if (key !== "sortBy" && key !== "sortAscending" && key !== "search") {
					if (value || !this.filterOptions[key]) {
						this.filterOptions[key] = value;
					}
				}
			}
			this.setFilters();
		},
		clearFilters() {
			gtag('event', 'clearFilter', { 'event_category': 'Opportunities', 'event_label': 'Filter'});
			this.filterOptions = this.defaultFilters();
			this.setFilters();
			if (this.isSuperAdmin || this.filters.officeId) {
				opportunitiesStore.dispatchGetOpportunities({ params: this.filters });
			}
			this.$refs.filterOptionsDropdown.onCloseOptions();
		},
		loadMore() {
			gtag('event', 'loadMore', { 'event_category': 'Opportunities', 'event_label': 'loadMore'});
			opportunitiesStore.commitSetOpportunitiesToken(opportunitiesStore.state.opportunitiesToken + 50);
			if (this.isSuperAdmin || this.filters.officeId) {
				opportunitiesStore.dispatchGetOpportunities({ params: { ...this.filters, continuationToken: this.opportunitiesToken } });
			}
		},
		exportOppCSV() {
			const config: CSVConfig = {
				headers: this.csvHeaders,
				selectors: {
					dataList: '.opportunity',
					dataItem: '[data-csv-header]',
					header: 'data-csv-header',
					value: 'data-csv-value'
				},
				filename: 'rptNISOpportunities.csv'
			};
			exportCSV(config);
		}
	},
});
